export function formatCurrency(value: number) {
  return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
}

export function formatInstantDate(iso?: string | null) {
  if (!iso) return '—';
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return '—';
  return date.toLocaleDateString('pt-BR', { day: '2-digit', month: 'short', year: 'numeric' });
}

export function formatDateOnly(iso?: string | null) {
  if (!iso) return '—';
  const [year, month, day] = iso.split('T')[0].split('-');
  if (!year || !month || !day) return '—';
  return `${day}/${month}/${year}`;
}

export function toInputDate(iso?: string | null) {
  if (!iso) return '';
  return iso.split('T')[0];
}

export function extractApiError(error: unknown, fallback: string) {
  const err = error as { response?: { data?: { errors?: string[] } } };
  return err?.response?.data?.errors?.[0] ?? fallback;
}

export function isUnauthorizedError(error: unknown) {
  const err = error as { response?: { status?: number } };
  return err?.response?.status === 401;
}
